// extracted by mini-css-extract-plugin
export default {"loaderwrapper":"PreLoader_loaderwrapper__qBfpA","slideOut":"PreLoader_slideOut__MD1uW","loader":"PreLoader_loader__CtsKp","fadeIn":"PreLoader_fadeIn__9-wLD"};